import React from 'react';
import { Form, FormItemProps } from 'antd';
import * as S from '../styles';

interface FormWrapperProps {
	name: string[];
	children: JSX.Element;
}

export function FormWrapper({ children, name, ...props }: Readonly<FormWrapperProps & FormItemProps>) {
	return (
		<S.InputsWrapper span={24}>
			<Form.Item name={name} {...props}>
				{children}
			</Form.Item>
		</S.InputsWrapper>
	);
}
